// extracted by mini-css-extract-plugin
module.exports = {"container":"StopGoKeywordsActionsCell_container__mPuAC","actionIcon":"StopGoKeywordsActionsCell_actionIcon__3MUTX"};